// Chakra Imports
import { Box, Breadcrumb, BreadcrumbItem, BreadcrumbLink, Button, Flex, Link, Text, useColorModeValue } from '@chakra-ui/react';
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { SidebarResponsive } from 'components/sidebar/Sidebar';
import routes from 'routes.js';
import AdminNavbarLinks from 'components/navbar/NavbarLinksAdmin';
import { ChevronLeft } from '@mui/icons-material';

export default function AdminNavbar(props) {
	const [scrolled, setScrolled] = useState(false);

	useEffect(() => {
		window.addEventListener('scroll', changeNavbar);

		return () => {
			window.removeEventListener('scroll', changeNavbar);
		};
	});

	const { secondary, user, brandText, username, localUser, location } = props;
	console.log(location)

	// Here are all the props that may change depending on navbar's type or state.(secondary, variant, scrolled)
	let mainText = useColorModeValue('navy.700', 'white');
	let secondaryText = useColorModeValue('gray.700', 'white');
	let navbarPosition = 'fixed';
	let navbarFilter = 'none';
	let navbarBackdrop = 'blur(20px)';
	let navbarShadow = 'none';
	let navbarBg = useColorModeValue('rgba(244, 247, 254, 0.2)', 'rgba(11,20,55,0.5)');
	let navbarBorder = 'transparent';
	let secondaryMargin = '50px';
	let paddingX = '15px';
	let gap = '0px';
	const changeNavbar = () => {
		if (window.scrollY > 1) {
			setScrolled(true);
		} else {
			setScrolled(false);
		}
	};
	let path = props.location.pathname?.split(brandText.toLowerCase().replace(" ", "-"))[1]?.split('/').slice(1)
	// console.log('props: ', props.location.pathname.split('/'))
	// console.log('props: ', props.brandText)
	// console.log(props.location.pathname.split(props.brandText.toLowerCase()))

	return (
		<Box
			position={navbarPosition}
			boxShadow={navbarShadow}
			bg={navbarBg}
			borderColor={navbarBorder}
			filter={navbarFilter}
			backdropFilter={navbarBackdrop}
			backgroundPosition='center'
			backgroundSize='cover'
			borderRadius='16px'
			borderWidth='1.5px'
			borderStyle='solid'
			transitionDelay='0s, 0s, 0s, 0s'
			transitionDuration=' 0.25s, 0.25s, 0.25s, 0s'
			transition-property='box-shadow, background-color, filter, border'
			transitionTimingFunction='linear, linear, linear, linear'
			alignItems={{ xl: 'center' }}
			display={'flex'}
			minH='55px'
			justifyContent={{ xl: 'center' }}
			lineHeight='25.6px'
			mx='auto'
			mt={secondaryMargin}
			pb='8px'
			right={{ base: '12px', md: '30px', lg: '30px', xl: '30px' }}
			px={{
				sm: paddingX,
				md: '10px'
			}}
			ps={{
				xl: '12px'
			}}
			pt='8px'
			top={{ base: '0' }}
			w={{
				base: 'calc(100vw - 6%)',
				md: 'calc(100vw - 8%)',
				lg: 'calc(100vw - 6%)',
				xl: 'calc(100vw - 300px)',
				'2xl': 'calc(100vw - 365px)'
			}}>
			<Flex
				w='100%'
				flexDirection={{
					// sm: 'column',
					md: 'row'
				}}
				alignItems={{ base: 'center' }}
				mb={gap}>
				{/* <SidebarResponsive routes={routes} /> */}
				<Box mb={{ md: '0px' }}>
					{!props.location.pathname.includes("friend-list") ? (
						<Breadcrumb separator='/'>
							<BreadcrumbItem color={secondaryText} fontSize='sm' mb='5px'>
								<BreadcrumbLink href={`/dashboard/${brandText.toLowerCase().replace(" ", "-")}`} color={secondaryText}>
									{brandText}
								</BreadcrumbLink>
							</BreadcrumbItem>
							{path && (
								path.map((item, index) => (
									<BreadcrumbItem color={secondaryText} key={index} fontSize='sm' mb='5px'>
										<BreadcrumbLink href={index === 0 ? `/dashboard/${brandText.toLowerCase().replace(" ", "-")}/${item}` : `#`} color={secondaryText}>
											{item == user?.id ? user.name : item}
										</BreadcrumbLink>
									</BreadcrumbItem>
								))
							)}
						</Breadcrumb>
					) : (
						<Button onClick={() => window.location.assign("/dashboard/profile#friend")}>
							<ChevronLeft />
							Back To Friend List
						</Button>
					)}

					{/* Here we create navbar brand, based on route name */}
					{/* <Link
						color={mainText}
						href='#'
						bg='inherit'
						borderRadius='inherit'
						fontWeight='bold'
						fontSize='34px'
						_hover={{ color: { mainText } }}
						_active={{
							bg: 'inherit',
							transform: 'none',
							borderColor: 'transparent'
						}}
						_focus={{
							boxShadow: 'none'
						}}>
						{brandText}
					</Link> */}
				</Box>
				{/* <Box ms='auto' w={{ sm: '100%', md: 'unset' }}>
					<AdminNavbarLinks
						onOpen={props.onOpen}
						logoText={props.logoText}
						secondary={props.secondary}
						fixed={props.fixed}
						scrolled={scrolled}
						user={props.user}
					/>
				</Box> */}
			</Flex>
			{/* {secondary ? <Text color='white'>{message}</Text> : null} */}
		</Box>
	);
}

AdminNavbar.propTypes = {
	brandText: PropTypes.string,
	variant: PropTypes.string,
	username: PropTypes.string,
	secondary: PropTypes.bool,
	fixed: PropTypes.bool,
	onOpen: PropTypes.func
};
